<template>
    <div class="exception-body access">
        <img src="assets/layout/images/logo-mides-white.svg" alt="mides-layout" class="logo" />

        <div class="exception-content">
            <div class="exception-title">ACCESO DENEGADO</div>
            <div class="exception-detail">Su usuario no cuenta con un nivel de seguridad adecuado. 
            <br>
            <!-- <a href="https://www.gub.uy/atencion-ciudadania" target="_blank">
            <Button label="Mas información aquí"  class="p-button-warning p-button-text mr-2 mb-2"/>
            </a> -->
            </div>
            <div class="p-mt-6" >
            <Button label="Salir" @click="logout" class="p-button-outlined p-button-warning p-mr-2 p-mb-2 p-mt-2" ></Button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
	methods: {
		logout() {
			if (localStorage.tokenExt){				
				window.location = localStorage.urlIDUruguay+"/logout?id_token_hint="+localStorage.tokenExt+"&post_logout_redirect_uri="+encodeURIComponent(localStorage.urlLogout);
                /* let url = localStorage.urlIDUruguay+"/logout?id_token_hint="+localStorage.tokenExt+"&post_logout_redirect_uri="+encodeURIComponent(localStorage.urlLogout);
			    localStorage.clear();		
                console.log(url);
			    window.location = url; */
			}
			else {
				this.$router.replace({ name: "login" });
			}
        },
	}
};
</script>
